//back to this
import { Layout, Menu } from "antd";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAdmin } from "./modules/useAdmin";

const { Header, Content } = Layout;
const { SubMenu } = Menu;

function AdminTemplate() {
  const navigate = useNavigate();
  const { isAdmin, checkAdmin } = useAdmin();

  useEffect(() => {
    checkAdmin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isAdmin) {
    return null;
  }

  return (
    <Layout>
      <Header>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["dashboard"]}
          className="responsive-menu"
        >
          <Menu.Item
            key="dashboard"
            onClick={() => navigate("/admin/dashboard")}
          >
            Dashboard
          </Menu.Item>
          <SubMenu key="roomManagement" title="Room & Rate">
            <Menu.Item
              key="roomingList"
              onClick={() => navigate("/admin/roominglist")}
            >
              Room Categories
            </Menu.Item>
            <Menu.Item key="addRoom" onClick={() => navigate("/admin/addroom")}>
              Add Room
            </Menu.Item>
            <Menu.Item
              key="ratePlans"
              onClick={() => navigate("/admin/rateplans")}
            >
              Rate Plans
            </Menu.Item>
            <Menu.Item
              key="promotions"
              onClick={() => navigate("/admin/promotions")}
            >
              Promotions
            </Menu.Item>
            <Menu.Item
              key="roomreview"
              onClick={() => navigate("/admin/roomreview")}
            >
              Room Review
            </Menu.Item>
          </SubMenu>
          <Menu.Item
            key="availability"
            onClick={() => navigate("/admin/roommanagement")}
          >
            Smart Calendar
          </Menu.Item>
          <Menu.Item
            key="channelmanager"
            onClick={() => navigate("/admin/channelmanager")}
          >
            Channel Manager
          </Menu.Item>
          <SubMenu key="propertySetting" title="Property Setting">
            <Menu.Item
              key="generalInfo"
              onClick={() => navigate("/admin/generalinfo")}
            >
              General Info
            </Menu.Item>
            <Menu.Item
              key="policies"
              onClick={() => navigate("/admin/policies")}
            >
              Policies
            </Menu.Item>
            <Menu.Item
              key="hotelrules"
              onClick={() => navigate("/admin/hotelrules")}
            >
              Hotel Rules
            </Menu.Item>
            <Menu.Item
              key="paymentMethods"
              onClick={() => navigate("/admin/payment-method")}
            >
              Payment Methods
            </Menu.Item>
            <Menu.Item
              key="addOnService"
              onClick={() => navigate("/admin/addonservices")}
            >
              Add On Services
            </Menu.Item>
            <Menu.Item key="users" onClick={() => navigate("/admin/users")}>
              Users
            </Menu.Item>
            <Menu.Item
              key="branding"
              onClick={() => navigate("/admin/branding")}
            >
              Branding Design
            </Menu.Item>
          </SubMenu>
          <SubMenu key="reservation" title="Reservation">
            <Menu.Item
              key="bookingList"
              onClick={() => navigate("/admin/bookinglist")}
            >
              Bookings
            </Menu.Item>
            <Menu.Item
              key="revealCard"
              onClick={() => navigate("/admin/retrieve-card-input")}
            >
              Retrieve Payment
            </Menu.Item>
          </SubMenu>
          <Menu.Item
            key="analytics"
            onClick={() => navigate("/admin/analytics")}
          >
            Analytics
          </Menu.Item>
        </Menu>
      </Header>
      <Content style={{ padding: "20px" }}>
        <Outlet /> {/* This is where the screen content will be injected */}
      </Content>
    </Layout>
  );
}

export default AdminTemplate;
